import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {
    FormGroup, Validators, FormControl, FORM_PROVIDERS, FORM_DIRECTIVES,
    REACTIVE_FORM_DIRECTIVES
} from "@angular/forms";
import {Contract} from "../domain/contract";
import {Vehicle} from "../domain/vehicle";
import {AlertComponent, TYPEAHEAD_DIRECTIVES} from "ng2-bootstrap";
import {ContractsService} from "../service/contracts.service";
import {Procedure} from "../domain/procedure";
import {DATE_VALID_CHARACTERS, DATE_VALIDATOR, DEFAULT_ERROR_MESSAGES, FILE_MAX_SIZE} from "../validators/validators";
import {Observable} from "rxjs/Observable";
import {ProcedureService} from "../service/procedure.service";
import {ExpirationType} from "../domain/expirationType";
import {ProcedureType} from "../domain/procedureType";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload";
import {ProcedureDocument} from "../domain/ProcedureDocument";
import {Router} from "@angular/router";
import {NavigationService} from "../service/navigation.service";
import {LoginService} from "../service/login.service";
import {Bank} from "../domain/bank";
import {BankService} from "../service/bank.service";

@Component({
    selector: 'procedures-new',
    template: require('./procedures.new.component.html'),
    styles: [require('./procedures.new.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        /*MyDatePicker,*/
        TYPEAHEAD_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS],
})

export class ProcedureNewComponent implements OnInit {

    public form: FormGroup;
    public vehicleId: string;
    public contract: Contract;
    public vehicle: Vehicle;
    public showVehicle: boolean;
    public canNew: boolean;
    public errorMessages: any;
    public errorMessage: string;
    public successMessage: string;
    public warningMessage: string;
    private todayStr: string;

    private filter: Vehicle;
    public vehicles: Vehicle[];
    public newProcedure: Procedure;
    public banks: Bank[];
    public bankSelected: Bank;

    public procedureTypeSelectedId: string;
    public expirationTypeSelectedId: string;
    public procedureType: ProcedureType[];
    public expirationType: ExpirationType[];

    public uploaderDocument: FileUploader;
    public hasDocumentDropZoneOver: boolean;

    //SAVE
    public isUploading: boolean;
    @ViewChild('inputDocument') inputAct: ElementRef;
    public loading: boolean;
    public SelectedVehicle: boolean;


    constructor(private contractsService: ContractsService,
                private procedureService: ProcedureService,
                private bankService: BankService,
                private router: Router,
                private navigationService: NavigationService,
                private loginService: LoginService) {
        this.init();
        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
    }

    public init(): void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;
        this.showVehicle = false;
        this.canNew = false;
        this.filter = new Vehicle();
        this.newProcedure = new Procedure();
        this.banks = [];

        let dateStrParts = new Date();
        this.todayStr = this.padLeft(dateStrParts.getDate().toString(), '0', 2) + '/' +
            this.padLeft((dateStrParts.getMonth() + 1).toString(), '0', 2) + '/' + dateStrParts.getFullYear();

        this.newProcedure.creationDate = this.todayStr;
        this.newProcedure.customDate = this.todayStr;

        this.uploaderDocument = new FileUploader({});
        this.hasDocumentDropZoneOver = false;

        this.isUploading = false;
        this.loading = false;
        this.SelectedVehicle = false;
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();
        this.canNew = userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');

        this.createFormGroup();
    }

    private createFormGroup() {
        this.form = new FormGroup({
            vehicleId: new FormControl(),
            contractNumber: new FormControl(),
            bankSelected: new FormControl(),
            newProcedureDate: new FormControl(this.newProcedure.creationDate, [Validators.required, DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
            newProcedureExpirationType: new FormControl(this.newProcedure.expirationType, [Validators.required]),
            newProcedureType: new FormControl(this.newProcedure.type, [Validators.required]),
            newProcedureDescription: new FormControl(this.newProcedure.description),
            newProcedureComment: new FormControl(this.newProcedure.comment),
            newProcedureCustomDate: new FormControl(this.newProcedure.customDate, [Validators.required, DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
            withSendMail: new FormControl(this.newProcedure.withSendMail)
        });
    }

    public find(): void {
        this.getData();
    }

    public goBack(event: any): void {
        event.preventDefault();
        window.history.back();
    }

    private getData() {
        this.errorMessage = null;

        this.vehicleId = null;

        if (this.filter.contract.contractNumber) {
            this.contractsService.getContractByContractNumberAndBank(this.filter.contract.contractNumber, this.bankSelected.id)
                .subscribe((data) => {
                this.contract = data;
                if (this.contract) {
                    this.contractsService.getVehicles(this.contract.id, 1, 10000)  //TODO: Test, anda, pero el 1,10000 estan como de mas
                        .subscribe((data) => {
                                this.vehicles = data.content;
                                //this.createFormGroup();
                                if (this.vehicles.length > 0) {
                                    this.showVehicle = true;
                                    //this.canNew = true;
                                    //this.setData();
                                }

                            },
                            () => {
                                this.bindError('Ocurrió un error al obtener los vehículos asociados al contrato.');
                            });
                }
            }, () => {
                this.bindError('Ocurrió un error al obtener el contrato asociado a los datos ingresados.');
            });
        }

        let forkTasks: Observable<any>[] = [];
        forkTasks.push(this.procedureService.getProcedureTypes());
        forkTasks.push(this.procedureService.getExpirationTypes());
        //forkTasks.push(this.procedureService.getVehicle(this.vehicleId));

        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this)
        );
    }

    public setData(data: any[]): void {
        this.procedureType = data[0];
        this.expirationType = data[1];

        this.expirationType = this.expirationType.filter(
            function (obj: ExpirationType) {
                return obj.description != 'NO VENCE';
            });

        this.procedureType = this.procedureType.filter(
            function (obj: ProcedureType) {
                return obj.name != 'LICENSE_PLATE';
            });

        this.expirationTypeSelectedId = this.expirationType[0].id;
        this.procedureTypeSelectedId = this.procedureType[0].id;

        this.expirationTypeChange(this.expirationTypeSelectedId);
        this.procedureTypeChange(this.procedureTypeSelectedId);

        this.updateUploaderUrl();

        this.procedureService.generateProcedureTempId()
            .subscribe(
                (response) => {
                    this.newProcedure.tempId = response.value;
                    this.updateUploaderUrl();
                },
                () => {
                    this.bindError('Ocurrió un error al generar un trámite.');
                });
    }

    public addNewProcedure(event: any): void {
        event.preventDefault();

        if(!this.SelectedVehicle) {
            this.searchVehicle();
            this.SelectedVehicle = true;
        } else {
            this.addNewProcedureToVehicle();
            this.clearMessages();
            this.bindWarning('Existen Trámites sin guardar.');
        }
    }

    private searchVehicle(): void {
        this.procedureService.getVehicle(this.vehicleId).subscribe((data) => {
                this.vehicle = data;
                this.addNewProcedureToVehicle();
                this.clearMessages();
                this.bindWarning('Existen Trámites sin guardar.');
            },
            () => {
                this.bindError('Ocurrió un error al obtener el vehículo asociado a la patente ingresada.');
            });
    }

    private addNewProcedureToVehicle(): void {
        this.uploaderDocument.queue.forEach((item) => {
            this.newProcedure.document = new ProcedureDocument();
            this.newProcedure.document.id = "temp/" + this.newProcedure.tempId;
            this.newProcedure.document.name = item.file.name;
        });

        if(this.vehicle) {
            this.vehicle.procedures.push((JSON.parse(JSON.stringify(this.newProcedure))));
            this.newProcedure = new Procedure();
            this.newProcedure.creationDate = this.todayStr;
            this.newProcedure.customDate = this.todayStr;

            this.expirationTypeSelectedId = this.expirationType[0].id;
            this.procedureTypeSelectedId = this.procedureType[0].id;
            this.expirationTypeChange(this.expirationTypeSelectedId);
            this.procedureTypeChange(this.procedureTypeSelectedId);

            this.procedureService.generateProcedureTempId()
                .subscribe(
                    (response) => {
                        this.newProcedure.tempId = response.value;
                        this.loading = true;
                        this.updateUploaderUrl();
                    },
                    () => {
                        this.bindError('Ocurrió un error al generar un trámite.');
                    });

            this.uploaderDocument.clearQueue();
        }
    }

    public checkIfNotValid(): boolean {
        if (!this.form.controls["newProcedureCustomDate"].valid) {
            return true;
        }
        /*!this.form.valid ||*/
        return this.uploaderDocument.isUploading || this.uploaderDocument.queue.length == 0;
    }

    public procedureTypeChange(newValue: any): void {
        let result = this.procedureType.filter(function (obj: ExpirationType) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.newProcedure.type = result[0];
        }

    }

    public expirationTypeChange(newValue: any): void {
        let result = this.expirationType.filter(function (obj: ExpirationType) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.newProcedure.expirationType = result[0];
        }
    }

    private updateUploaderUrl(): void {
        let fileOwnerId = this.newProcedure.tempId;
        this.uploaderDocument = new FileUploader({
            url: 'procedure/' + fileOwnerId + '/upload',
            autoUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        });
    }

    public save(): void {
        this.clearMessages();
        this.isUploadingAFile();
        if (!this.checkAllBeforeSave()) {
            this.procedureService.save(this.vehicle).subscribe(
                (saved: Vehicle) => {
                    this.vehicle = saved;
                    this.successMessage = 'El trámite se guardó con éxito';
                    this.updateViewAfterSave();

                    if (this.checkPreSaveProcedures()) {
                        this.bindWarning('Existen Trámites sin guardar.');
                    }
                },
                () => {
                    this.bindError('Ocurrió un error al guardar la información.');
                });
        } else {
            this.bindError('Existe un archivo pendiente de subida. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
        }
    }

    public isUploadingAFile() {
        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
    }

    private checkAllBeforeSave() {
        return this.isUploading || !this.form.valid || this.uploaderDocument.isUploading;
    }

    private updateViewAfterSave(): void {
        this.uploaderDocument.clearQueue();
        this.vehicle.procedures.forEach((procedure, index) => {
            if (procedure.id == undefined || procedure.id == null) {
                this.vehicle.procedures.splice(index, 1);
            }
        });
    }

    private checkPreSaveProcedures(): boolean {
        let hasPreSaveProcedures = false;
        this.vehicle.procedures.forEach(procedure => {
            if (procedure.id === undefined || procedure.id === null) {
                hasPreSaveProcedures = true;
            }
        });
        return hasPreSaveProcedures;
    }

    public editProcedure(event: any, item: Procedure): void {
        event.preventDefault();
        this.navigationService.setBackParameters({tabSelected: 'procedures'});
        this.router.navigate(['app/home/editSingleProcedure', item.id]); // Ya existia editProcedure, que lleva a esta vista en realidad
    }

    public deleteProcedure(event: any, index: number, id: string, idTemp: string): void {
        event.preventDefault();

        this.clearMessages();

        let notPending = false;
        if (id != undefined && id != null) {
            notPending = true;
            this.procedureService.delete(id).subscribe(
                () => {
                    this.successMessage = 'El trámite se eliminó con éxito';

                    this.vehicle.procedures.splice(index, 1);

                    if (this.checkPreSaveProcedures()) {
                        this.clearMessages();
                        this.bindWarning('Existen Trámites sin guardar.');
                    }
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar el trámite.');
                });
        }
        if (idTemp != undefined && idTemp != null) {
            notPending = true;
            this.procedureService.deleteTempProcedureDocument(idTemp).subscribe(
                () => {
                    this.successMessage = 'La carga de trámite se eliminó con éxito';

                    this.vehicle.procedures.splice(index, 1);

                    if (this.checkPreSaveProcedures()) {
                        this.clearMessages();
                        this.bindWarning('Existen Trámites sin guardar.');
                    }
                },
                () => {
                    this.bindError('Ocurrió un error al eliminar el trámite.');
                });
        }

        if (!notPending) {
            this.vehicle.procedures.splice(index, 1);

            if (this.checkPreSaveProcedures()) {
                this.bindWarning('Existen Trámites sin guardar.');
            }
        }
    }

    public removeDocument(): void {
        this.newProcedure.document = null;
    }

    public removeDocumentFromQuee(item: any): void {
        this.procedureService.deleteTempProcedureDocument(this.newProcedure.tempId).subscribe(
            (result) => item.remove(),
            () => {
                this.bindError('Ocurrió un error al eliminar el documento de trámite.');
            });
    }

    public fileOverDocument(e: any): void {
        this.hasDocumentDropZoneOver = e;
    }

    private bindError(messageError: string): void {
        if (this.errorMessage == null
        ) {
            this.errorMessage = messageError;
        }
        else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    private bindWarning(messageWarning: string): void {
        if (this.warningMessage == null) {
            this.warningMessage = messageWarning;
        } else {
            this.warningMessage = this.warningMessage.toString() + ' ' + messageWarning;
        }
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
        this.warningMessage = null;
    }

    private padLeft(text: string, padChar: string, size: number): string {
        return (String(padChar).repeat(size) + text).substr((size * -1), size);
    }


}


/** WEBPACK FOOTER **
 ** ./src/app/procedures/procedures.new.component.ts
 **/